import * as React from "react";
import { Fragment } from "react";
import OrderPDFHeader from "../OrderPDFHeader";
import { Text, View } from "@react-pdf/renderer";
import { UserType } from "../../../entities/User";
import LicenceDetails from "../LicenceDetails";
import { OrderStatus, TApiOrderDetails, OrderCategory } from "../../../api/endpoints/Order";
import { OrderPdfProps } from "../types";
import { formatVolumeBand } from "../../../utils/Format";

interface IProps extends OrderPdfProps {
  order: TApiOrderDetails;
}

const OrderDetailsPdf = (props: IProps) => {
  const { user, order, provider, dataDeliverer, servicePackage, volumeBand, styles } = props;
  const userType = user.type;

  return (
    <Fragment>
      <OrderPDFHeader order={order} styles={styles} />

      <View
        style={[
          styles.flexRow,
          styles.flexStretch,
          styles.alignTop,
          styles.paddingBottomNormal
        ]}
      >
        <View>
          <Text style={styles.title}>Order details</Text>

          {
            order.category === OrderCategory.EU_CUTOUT &&
            <View style={[styles.sentence, styles.listItem]}>
              <Text style={styles.bold}>Order type: &nbsp;</Text>
              <Text>European cut-out</Text>
            </View>
          }

          {
            provider &&
            <View style={[styles.sentence, styles.listItem]}>
              <Text style={styles.bold}>Licensor: &nbsp;</Text>
              <Text>{provider.name}</Text>
            </View>
          }

          {
            dataDeliverer &&
            <View style={[styles.sentence, styles.listItem]}>
              <Text style={styles.bold}>Data deliverer: &nbsp;</Text>
              <Text>{dataDeliverer.name}</Text>
            </View>
          }

          {
            servicePackage &&
            <View style={[styles.sentence, styles.listItem]}>
              <Text style={styles.bold}>Service Package: &nbsp;</Text>
              <Text>{servicePackage.title}</Text>
            </View>
          }

          {
            volumeBand && (order.category === OrderCategory.REALTIME || order.category === OrderCategory.EU_CUTOUT) &&
            <View style={[styles.sentence, styles.listItem]}>
              <Text style={styles.bold}>Volume Band: &nbsp;</Text>
              <Text>{`${formatVolumeBand(volumeBand)} per day`}</Text>
            </View>
          }

          {
            userType !== UserType.Customer &&
            <View style={[styles.sentence, styles.listItem]}>
              <Text style={styles.bold}>Customer: &nbsp;</Text>
              <Text>{order.customer}</Text>
            </View>
          }

          <LicenceDetails order={order} user={user} styles={styles} />


          {
            Boolean(order.status_note) && (order.status === OrderStatus.REJECTED) &&
            <View style={[styles.sentence, styles.listItem]}>
              <Text style={styles.bold}>Rejection reason: &nbsp;</Text>
              <Text>{order.status_note}</Text>
            </View>
          }
        </View>

        <View style={styles.reference}>
          <View style={styles.sentence}>
            <Text style={styles.bold}>Reference: &nbsp;</Text>
            <Text>{order.id}</Text>
          </View>
        </View>
      </View>
    </Fragment>
  )
}

export default OrderDetailsPdf;
